$bog_builderui_field $mol_string
	minimal_height 36
